import { isJson } from "./json.util";
import { wlLocalStorage } from "./localStorage.util";

export const getHiddenAssistsIds = (): number[] => {
  const hiddenAssists = wlLocalStorage.getItem('hidden_assists');

  return isJson(hiddenAssists)
    ? JSON.parse(String(hiddenAssists))
    : [];
}

export const hasCustomFlow = () => {
  const subdomain = wlLocalStorage.getSubdomain();

  const subdomainsList = ['censoibge'];

  return subdomainsList.includes(subdomain as string);
}

export const getUrlGuiaBeneficios = (idProduto: string) => {
  const docsMap: Record<string, string> = {
    '6994880490': 'https://www.sulamerica.com.br/emkt/saude/Guia_de_Benefiicios_e_Assistencias_Acidentes_Pessoais_V14_04.24.pdf',
    '7986106960': 'https://www.sulamerica.com.br/emkt/saude/Guia_de_Beneficios_Vida_Flex_v6.pdf'
  }

  return docsMap[idProduto];
}
export const getUrlGuiaProduto = (idProduto: string) => {
  const docsMap: Record<string, string> = {
    '6994880490': 'https://docs.plataformadeseguros.com.br/documentos/guia_produto_6994880490.pdf',
    '7986106960': 'https://portal.sulamericaseguros.com.br/data/files/91/45/F7/BD/3050291078A72029B808D4A8/CG%20VIDA%20FLEX_08.2024.pdf'
  }

  return docsMap[idProduto];
}